import { LazyDialogAgeGate } from '#components';

export default defineNuxtPlugin({
  name: 'kygunco:age',
  dependsOn: ['kygunco:bus'],
  parallel: true,
  setup: () => {
    const { $bus } = useNuxtApp();
    const { dialog } = useQuasar();

    const age = useCookie<number | null>('kygunco_age_confirmed', {
      secure: true,
      sameSite: 'lax',
      maxAge: DAY_IN_SECONDS * 30,
    });

    const minimum = 18;

    const confirm = (confirmed: MaybeRef<number>) =>
      (age.value = toValue(confirmed));

    const check = (min?: MaybeRef<number>) =>
      age.value ? age.value >= toValue(min ?? minimum) : false;

    const confirmed = computed(() => !!age.value && age.value >= minimum);

    $bus.once('app:interacted', () => {
      if (confirmed.value) {
        $bus.emit('app:ungated');
        return;
      }

      dialog({
        component: LazyDialogAgeGate,
        componentProps: {
          age: minimum,
        },
      }).onOk(() => $bus.emit('app:ungated'));
    });

    return {
      provide: {
        age: {
          age: readonly(age),
          minimum,
          confirmed,
          confirm,
          check,
        },
      },
    };
  },
});
